import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { AxiosDelete } from "../../../api/DeleteApi";
import { AxiosList, AxiosSearch } from "../../../api/ListApi";
import Idx from "../../../recoil/Idx";
import Menu from "../../../recoil/Menu";
import PaginateNumber from "../../../recoil/PaginateNumber";
import Pagination from "../../components/Pagination";

const Leaved = () => {
    
    const [ list, setList ] = useState([]);
    const [ page, setPage ] = useState([]);    

    const [ , setContent] = useRecoilState(Menu);
    const [ , setIdx] = useRecoilState(Idx);
    const [ paginateNumber, ] = useRecoilState(PaginateNumber);

    const [ timer, setTimer ] = useState(null);
    const [ filter, setFilter ] = useState('');
    const [ keyword, setKeyword ] = useState('');

    //
    useEffect(() => {

        let data = null;

        // api
        if(!paginateNumber) {
            data = AxiosList('secessionMember');
        } else {
            data = AxiosList('secessionMember?page=' + paginateNumber);
        }
        
        data.then((list) => {
            if(list.data.success) {
                setList(list.data.data.data);
                setPage(list.data.data.links);
            }
        })

    }, [])

    // search
    useEffect(() => {
        if(keyword) {search()}
    }, [keyword])

    //
    const searchOnChangeHandle = (e) => {
        setKeyword(e.target.value);
    }

    //
    const detailOnClickHandle = (idx) => {
        setIdx(idx);
        setContent('DetailBusiness');
    };

    //
    const userleavedOnClickHandle = (idx) => {

        if(!window.confirm("정말로 삭제하시겠습니까?")) return;
        
        const data = AxiosDelete('secessionMember', idx);

        data.then((res) => {
            if(res.data.success) {
                alert('정상적으로 삭제되었습니다.');
                window.location.reload();
            } else {
                alert('일시적인 오류로 인해 삭제를 실패하였습니다.');
            }
        });

    }

    //
    const busginessFilterOnChage = (e) => {
        setFilter(e.target.value);
    }

    //
    const search = () => {

        clearTimeout(timer);

        const callApiTimer = setTimeout(() => {

            const url = 'https://api.commotree.com/api/search/secessionMember';

            const data = AxiosSearch(url, keyword);

            data.then(item => {
                setList(item.data.data.data);
                setPage(item.data.data.links);
            })

        }, 550);

        setTimer(callApiTimer);

    }

    //
    const paginateListHandle = (data) => {
        setList(data.data.data.data);
        setPage(data.data.data.links);
    };

    return (
        <main id="main" className="member-set withdrawal">
            <header id="menu"></header>
            <div className="container">
                <div className="title-wrap">
                    <span className="title">탈퇴 회원</span>
                    <div className="right-wrap">
                        <div className="search-wrap">
                            <div className="search">
                                <input 
                                    type="text" 
                                    placeholder="회사명, 회원명, 연락처로 검색" 
                                    onChange={(e) => searchOnChangeHandle(e)}
                                />
                                <i className="xi-search"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="contents-wrap">
                    <div className="table-container">
                        <div className="table-wrap">
                            <table className="management-table">
                                <colgroup>
                                    <col width="7%" />
                                    <col width="10%"  />
                                    <col width="18%"  />
                                    <col width="20%"  />
                                    <col width="20%"  /> 
                                    <col width="20%"  />
                                    <col width="7%"  />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>분류</th>
                                        <th>아이디</th>
                                        <th>회사명</th>
                                        <th>이메일</th>
                                        <th>담당자명/회원명</th>
                                        <th>담당자연락처/연락처</th>
                                        <th>관리</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        list ?
                                            list.map((user, idx) => {
                                                return (
                                                    <tr key={idx}>
                                                        <td>
                                                            {
                                                                user.type == 0 ?
                                                                "개인"
                                                                :
                                                                "기업"
                                                            }
                                                        </td>
                                                        <td>
                                                            com1234
                                                        </td>
                                                        <td>
                                                            {
                                                                user.company_name == 0 ?
                                                                ""
                                                                :
                                                                user.company_name
                                                            }
                                                        </td>
                                                        <td>
                                                            {user.email}
                                                        </td>
                                                        <td>
                                                            {user.name}
                                                        </td>
                                                        <td>
                                                            {user.phone}
                                                        </td>
                                                        <td>
                                                            <a 
                                                                className="btn-del"
                                                                onClick={() => userleavedOnClickHandle(user.id)}
                                                            >
                                                                삭제
                                                            </a>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            :
                                            ''
                                    }
                                </tbody>
                            </table>
                        </div>

                        <Pagination 
                            page={page} 
                            returnPaginateData={paginateListHandle}
                        />

                    </div>
                </div>
            </div>
        </main>
    );

};

export default Leaved;